import { c as _c } from "react/compiler-runtime";
import { NumberDisplay, TextLabel } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { useItemsCount } from "./ItemsCountProvider";
import { ItemsCountSkeleton } from "./ItemsCountSkeleton";
function ItemsCountBase(t0) {
  const $ = _c(12);
  const {
    totalCount,
    selectedCount,
    hasMore,
    subject: t1
  } = t0;
  const subject = t1 === undefined ? "item" : t1;
  const t = useTranslations("ItemsCount");
  let t2;
  if ($[0] !== hasMore || $[1] !== totalCount) {
    t2 = function renderCountDisplay() {
      if (!totalCount) {
        return <NumberDisplay display="quantity" value={0} />;
      }
      if (!hasMore) {
        return <NumberDisplay display="full" value={totalCount} />;
      }
      return <NumberDisplay display="quantity" value={totalCount} />;
    };
    $[0] = hasMore;
    $[1] = totalCount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const renderCountDisplay = t2;
  let t3;
  if ($[3] !== renderCountDisplay) {
    t3 = renderCountDisplay();
    $[3] = renderCountDisplay;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const countDisplay = t3;
  let t4;
  if ($[5] !== countDisplay || $[6] !== hasMore || $[7] !== selectedCount || $[8] !== subject || $[9] !== t || $[10] !== totalCount) {
    t4 = <TextLabel className="whitespace-nowrap leading-none" color="text-secondary" data-testid="results-count" size="xs">{selectedCount ? <><NumberDisplay display="quantity" value={selectedCount} /> /{" "}{countDisplay}{hasMore ? "+" : ""} {t("selected")}</> : <>{countDisplay}{hasMore ? "+" : ""} {totalCount === 1 ? subject : `${subject}s`}</>}</TextLabel>;
    $[5] = countDisplay;
    $[6] = hasMore;
    $[7] = selectedCount;
    $[8] = subject;
    $[9] = t;
    $[10] = totalCount;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
export function ItemsCount(t0) {
  const $ = _c(4);
  const {
    subject: t1
  } = t0;
  const subject = t1 === undefined ? "item" : t1;
  const itemsCount = useItemsCount();
  if (!itemsCount || itemsCount.fetching) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ItemsCountSkeleton />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  let t2;
  if ($[1] !== itemsCount || $[2] !== subject) {
    t2 = <ItemsCountBase {...itemsCount} subject={subject} />;
    $[1] = itemsCount;
    $[2] = subject;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}